import { Component, Input } from '@angular/core';
import { WwePortfolioPosition } from '@ddt-web/wealth-web';

@Component({
	selector: 'hl-proxy-list',
	templateUrl: './proxy-list.component.html',
	styleUrls: ['./proxy-list.component.scss']
})
export class ProxyListComponent {
	@Input() public portfolio: WwePortfolioPosition;

}
